import styled from '@emotion/styled';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';

export const NoResultsText = styled.p`
  text-align: center;
  margin-bottom: ${SPACING.LG};
`;

export const ListHed = styled.p`
  margin-bottom: ${SPACING.MD};
`;

export const StyledUl = styled.ul`
  list-style: disc;
  margin-bottom: ${SPACING.MD};
  list-style-position: inside;
`;
